<template>
  <div class="base-info">
    <div class="base-info-item">
      <el-row v-if="filterBaseInfo">
        <el-col :span="12" v-for="(info, key) in filterBaseInfo" :key="key" v-if="key !== '经营范围' && key !== '企业地址' && key !== '企业简介'">
          <el-row type="flex" class="risks">
            <el-col class="risks-span bg" :span="8">
              <el-popover
                placement="top"
                trigger="click"
                :content="key">
                <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ key }}</span>
              </el-popover>
            </el-col>
            <el-col class="risks-span" :span="16">
              <el-popover
                placement="top"
                trigger="click"
                :content="info">
                <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ info }}</span>
              </el-popover>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24" v-else>
          <el-row type="flex" class="risks">
            <el-col class="risks-span bg" :span="4">
              <span>{{ key }}</span>
            </el-col>
            <el-col class="risks-span" :span="20">
              <span>{{ info }}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyBaseInfo',
  components: {
  },
  props: {
    companyName: {
      type: String,
      default: ''
    },
    showDesc: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filterBaseInfo () {
      if (this.showDesc && this.baseInfo && Object.keys(this.baseInfo).length > 0) {
        const keysToInclude = ['成立日期', '企业年龄', '信用等级', '纳税人资质', '注册资本', '实缴资本', '是否小微企业', '最新年报营业收入', '企业规模', '参保人数']
        const filteredInfo = Object.fromEntries(
          Object.entries(this.baseInfo.info).filter(([key]) => keysToInclude.includes(key))
        )

        // 添加 '企业年龄' 字段
        if (filteredInfo['成立日期']) {
          const currentDate = new Date();
          const foundingDate = new Date(filteredInfo['成立日期']);
          const years = currentDate.getFullYear() - foundingDate.getFullYear();
          const months = currentDate.getMonth() - foundingDate.getMonth();

          // 根据计算结果构造年龄字符串
          filteredInfo['企业年龄'] = `${years}年${months >= 0 ? months : months + 12}月`;
        }

        return  Object.fromEntries(
          keysToInclude
            .filter(key => key in filteredInfo) // 过滤存在的键
            .map(key => [key, filteredInfo[key]]) // 按顺序重建对象
        )

      } else if (this.baseInfo) {
        return this.baseInfo.info
      } else {
        return {}
      }
    }
  },
  watch: {
    companyName: {
      immediate: true,
      handler (val) {
        if (val) this.fetchData()
      }
    }
  },
  data () {
    return {
      baseInfo: {},
    }
  },
  methods: {
    fetchData () {
      const company = { company_name: this.companyName, key: '基本信息' }
      this.$axios.post('/api/admin/upload_tasks/key/risks', { company }, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.baseInfo = data.data
          }
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.risks {
  border: 1px solid #ebeef5;
}
.risks-span {
  display: flex;
  line-height: .4rem;
  padding: 10px;
}
.risks-span span {
  width: 100%;
}
.risks-span-info {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bg {
  border-right: 1px solid #ebeef5;
  color: #909399;
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyBaseInfo.vue